import { ReactNode } from 'react';
import getVarianceStyle from '../../utils/varianceStyle';
import Tooltip from '../toolTip';
import VarianceIndicator from './varianceIndicator';
import { HeadlineCardProps } from '../../types/global';

export default function HeadlineCard({
  text, tooltip, displayNumber, variance, trendUpward, children, icon: trendIcon, footer,
}: Readonly<HeadlineCardProps>) {
  let varianceElement: ReactNode = null;
  if (variance && variance !== 'NA') {
    varianceElement = <VarianceIndicator variance={variance} trendUpward={trendUpward} />;
  } else if (trendUpward) {
    const { iconColour, icon } = getVarianceStyle(displayNumber, trendUpward);
    varianceElement = <span className={iconColour}>{icon}</span>;
  }

  return (
    <div className="flex flex-col grow card flex-1 bg-white !m-0">
      <div className="p-2 flex gap-2 items-start">
        {trendIcon && <span className="text-xl">{trendIcon}</span>}
        <div className="flex justify-center items-center gap-2">
          <span title={text} className="text-base text-wrap ">{text}</span>
          {tooltip && <Tooltip text={tooltip} label={tooltip} />}
        </div>
      </div>
      <div id="headline-figures-graph-container" className="px-2 flex sm:flex-row flex-col md:justify-between md:items-start items-start mt-auto">
        <div id="headline-figures-container" className=" flex flex-col justify-between gap-4">
          <div className="flex flex-row items-center gap-2">
            <span className="lg:text-3xl text-xl font-semibold">{displayNumber}</span>
            {varianceElement}
          </div>

        </div>
        <div id="headline-card-children-container">
          { children || ''}
        </div>
      </div>
      <span className="text-piptext-body text-xs font-medium mt-auto p-2">{footer}</span>
    </div>
  );
}
